import React from "react";

import { faFingerprint } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import QueryTags, { QueryTagType } from "features/Queries/QueryTags";
import Popover from "ui/Popover";

import { normalizeMissingQueryText } from "../util";

function QueryDetailsTitle({
  fingerprint,
  truncatedQuery,
  tags = [],
  additionalNode,
}: {
  fingerprint: string;
  truncatedQuery: string;
  tags?: QueryTagType[];
  additionalNode?: React.ReactNode;
}) {
  const tagsList: QueryTagType[] = [
    {
      id: "fingerprint",
      key: (
        <Popover
          content="A query fingerprint represents the abstracted form of a query and enables the grouping of similar queries together. This value is calculated using the pg_query library."
          popupClassName="!text-[12px]"
        >
          <FontAwesomeIcon
            icon={faFingerprint}
            className="text-[#666] text-[10px]"
          />{" "}
          fingerprint
        </Popover>
      ),
      value: fingerprint,
    },
    ...tags,
  ];

  const titleQuery = normalizeMissingQueryText(truncatedQuery);
  return (
    <div>
      <h2 className="text-[16px] text-[#606060] m-0 py-[9px] font-query font-medium overflow-visible leading-[26px]">
        {titleQuery}
      </h2>
      <div className="text-[12px] block mt-[-5px] mb-[10px] mx-0">
        <QueryTags tags={tagsList} additionalNode={additionalNode} />
      </div>
    </div>
  );
}

export default QueryDetailsTitle;
